<template>
  <v-card>
    <v-card-title class="d-flex justify-space-between align-center">
      <h3>Interaction Wrap up</h3>

      <span class="red--text font-weight-bold">
        {{ currentTime }}
      </span>
    </v-card-title>
    <v-card-text>
      <v-alert v-if="globalServerErrors !== null" dense outlined type="error">
        <p
          class="mb-0"
          v-for="globalErr in globalServerErrors"
          :key="globalErr"
        >
          {{ globalErr[0] }}
        </p>
      </v-alert>
      <formWrapper :validator="$v.task">
        <form class="form-box">
          <v-row>
            <v-col md="4" cols="12">
              <form-group name="channel_id" attribute="fields.channel">
                <template slot-scope="{ attrs, listeners }">
                  <v-select
                    :items="channels"
                    item-text="name"
                    item-value="id"
                    regular
                    clearable
                    v-bind="attrs"
                    v-on="listeners"
                    v-model="task.channel_id"
                  ></v-select>
                </template>
              </form-group>
            </v-col>
            <v-col md="4" cols="12">
              <form-group
                name="classification_id"
                attribute="fields.classification"
              >
                <template slot-scope="{ attrs, listeners }">
                  <v-select
                    :items="classifications"
                    item-text="name"
                    item-value="id"
                    regular
                    clearable
                    v-bind="attrs"
                    v-on="listeners"
                    v-model="task.classification_id"
                  ></v-select>
                </template>
              </form-group>
            </v-col>
            <v-col md="4" cols="12">
              <form-group name="action_id" attribute="fields.action">
                <template slot-scope="{ attrs, listeners }">
                  <v-select
                    :items="actions"
                    item-text="name"
                    item-value="id"
                    regular
                    clearable
                    v-bind="attrs"
                    v-on="listeners"
                    v-model="task.action_id"
                  ></v-select>
                </template>
              </form-group>
            </v-col>
            <v-col cols="12">
              <form-group name="notes" attribute="fields.notes">
                <template slot-scope="{ attrs, listeners }">
                  <v-textarea
                    regular
                    v-model="task.notes"
                    v-bind="attrs"
                    v-on="listeners"
                  ></v-textarea>
                </template>
              </form-group>
            </v-col>
            <v-col cols="12" v-if="checking">
              <v-row>
                <v-col sm="2" cols="12" class="transparent-slot">
                  <h3>{{ "Task #" + task_serial }}</h3>

                  <v-checkbox
                    v-model="task.close_task"
                    false-value="0"
                    true-value="1"
                    label="Close Task"
                    class="ma-0 pa-0"
                  ></v-checkbox>
                </v-col>
                <v-col sm="3" cols="12">
                  <form-group name="due_date" :attribute="`fields.due_date`">
                    <template slot-scope="{ attrs, listeners }">
                      <!-- :date-time="task.due_date" -->
                      <date-time-picker
                        :listeners="listeners"
                        v-model.trim="task.due_date"
                        :textFieldProps="{ ...attrs, regular: true }"
                        timeFormat="HH:mm:ss"
                        :allowedDates="allowedDates"
                        :disabled="retunBoolean()"
                      ></date-time-picker>
                      <!-- :isEdit="isEdit" -->
                    </template>
                  </form-group>
                </v-col>
                <v-col sm="3" cols="12">
                  <form-group
                    name="escalation_level_close"
                    attribute="fields.escalation_level_close"
                  >
                    <template slot-scope="{ attrs, listeners }">
                      <v-select
                        :items="escalated"
                        item-text="name"
                        item-value="id"
                        regular
                        clearable
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="task.escalation_level"
                        :disabled="retunBoolean()"
                      ></v-select>
                    </template>
                  </form-group>
                </v-col>
                <v-col sm="2" cols="12" v-if="queueAgent === true">
                  <form-group
                    name="agent_id_close"
                    attribute="fields.agent_close"
                  >
                    <template slot-scope="{ attrs, listeners }">
                      <v-select
                        :items="agents"
                        item-text="name"
                        item-value="id"
                        regular
                        clearable
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="task.agent_id"
                        :disabled="retunBoolean()"
                      ></v-select>
                    </template>
                  </form-group>
                </v-col>
                <v-col sm="2" cols="12" v-else>
                  <form-group
                    name="queue_id_close"
                    attribute="fields.queue_close"
                  >
                    <template slot-scope="{ attrs, listeners }">
                      <v-select
                        :items="queues"
                        item-text="name"
                        item-value="id"
                        regular
                        clearable
                        v-bind="attrs"
                        v-on="listeners"
                        v-model="task.queue_id"
                        :disabled="retunBoolean()"
                      ></v-select>
                    </template>
                  </form-group>
                </v-col>
                <v-col sm="2" cols="12" class="transparent-slot">
                  <v-switch
                    v-model="queueAgent"
                    inset
                    :label="queueAgent ? 'Queue' : 'Agent'"
                    color="success"
                    :disabled="retunBoolean()"
                  ></v-switch>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <h2>
                <span>Task</span
                ><v-btn
                  text
                  small
                  outlined
                  color="success"
                  bold
                  class="ml-4"
                  rounded
                  @click="addNewTask"
                  ><v-icon left small>mdi-pencil</v-icon>Create Task</v-btn
                >
              </h2>
            </v-col>
            <template v-if="taskAdd">
              <v-col md="4">
                <form-group name="subject" :attribute="`fields.subject`">
                  <template slot-scope="{ attrs, listeners }">
                    <v-text-field
                      v-bind="attrs"
                      v-on="listeners"
                      regular
                      v-model="task_adding.subject"
                    ></v-text-field>
                  </template>
                </form-group>
              </v-col>
              <v-col md="4" cols="12">
                <form-group name="due_date" :attribute="`fields.due_date`">
                  <template slot-scope="{ attrs, listeners }">
                    <date-time-picker
                      :listeners="listeners"
                      v-model.trim="task_adding.due_date"
                      :date-time="task_adding.due_date"
                      :textFieldProps="{ ...attrs, regular: true }"
                      timeFormat="HH:mm:ss"
                      :allowedDates="allowedDates"
                    ></date-time-picker>
                    <!-- :isEdit="isEdit" -->
                  </template>
                </form-group>
              </v-col>
              <v-col md="4" cols="12">
                <form-group name="type_id" attribute="fields.task_type">
                  <template slot-scope="{ attrs, listeners }">
                    <v-select
                      :items="taskTypes"
                      item-text="name"
                      item-value="id"
                      regular
                      clearable
                      v-bind="attrs"
                      v-on="listeners"
                      v-model="task_adding.type_id.id"
                      @change="taskTypeID"
                    ></v-select>
                  </template>
                </form-group>
              </v-col>
              <v-col sm="2" cols="12" v-if="queueAgentTask === true">
                <form-group name="queue_id" attribute="fields.queue">
                  <template slot-scope="{ attrs, listeners }">
                    <v-select
                      :items="queues"
                      item-text="name"
                      item-value="id"
                      regular
                      clearable
                      v-bind="attrs"
                      v-on="listeners"
                      v-model="task.queue_id"
                    ></v-select>
                  </template>
                </form-group>
              </v-col>
              <v-col md="2" cols="12" v-else>
                <form-group name="agent_id" attribute="fields.agent">
                  <template slot-scope="{ attrs, listeners }">
                    <v-select
                      :items="agents"
                      item-text="name"
                      item-value="id"
                      regular
                      clearable
                      v-bind="attrs"
                      v-on="listeners"
                      v-model="task_adding.agent_id.id"
                      @change="agentID"
                    ></v-select>
                  </template>
                </form-group>
              </v-col>

              <v-col sm="2" cols="12" class="transparent-slot">
                <v-switch
                  v-model="queueAgentTask"
                  inset
                  :label="queueAgentTask ? 'Agent' : 'Queue'"
                  color="success"
                ></v-switch>
              </v-col>
              <v-col md="4" cols="12">
                <form-group name="status_id" attribute="fields.status_id">
                  <template slot-scope="{ attrs, listeners }">
                    <v-select
                      :items="taskStatuses"
                      item-text="name"
                      item-value="id"
                      regular
                      clearable
                      v-bind="attrs"
                      v-on="listeners"
                      v-model="task_adding.status_id.id"
                      @change="statusID"
                    ></v-select>
                  </template>
                </form-group>
              </v-col>
              <v-col md="4" cols="12">
                <form-group
                  name="escalation_level"
                  attribute="fields.escalation_level"
                >
                  <template slot-scope="{ attrs, listeners }">
                    <v-select
                      :items="escalated"
                      item-text="name"
                      item-value="id"
                      regular
                      clearable
                      v-bind="attrs"
                      v-on="listeners"
                      v-model="task_adding.escalation_level.id"
                      @change="escalationID"
                    ></v-select>
                  </template>
                </form-group>
              </v-col>
              <v-col cols="12">
                <form-group
                  name="added_notes"
                  :attribute="`fields.added_notes`"
                >
                  <template slot-scope="{ attrs, listeners }">
                    <v-textarea
                      v-bind="attrs"
                      v-on="listeners"
                      regular
                      v-model="task_adding.notes"
                    ></v-textarea>
                  </template>
                </form-group>
              </v-col>
              <v-col cols="3">
                <v-btn
                  primary
                  color="success"
                  bold
                  width="100%"
                  @click="addTableTask"
                  >Add</v-btn
                >
              </v-col>
            </template>
            <v-col cols="12" v-if="tasks_added.length > 0">
              <v-data-table
                :headers="tasks_headers"
                :items="tasks_added"
                hide-default-footer
                :mobile-breakpoint="0"
                :items-per-page="20"
                class="table"
              >
                <template v-slot:item="{ item }">
                  <tr>
                    <td class="text-sm-center">{{ item.subject }}</td>
                    <td class="text-sm-center">
                      {{ item.due_date | moment("Do,MMM' YYYY hh:mm:ss") }}
                    </td>
                    <td class="text-sm-center">
                      {{ item.type_id.name }}
                    </td>

                    <td class="text-sm-center">
                      {{ item.agent_id.name }}
                    </td>
                    <td class="text-sm-center">
                      {{ item.status_id.name }}
                    </td>
                    <td class="text-sm-center">
                      {{ item.escalation_level.name }}
                    </td>
                    <td class="text-sm-center">
                      {{ item.notes }}
                    </td>

                    <td class="text-sm-center">
                      <i
                        class="icon-delete delete"
                        @click="handleDelete(item)"
                      ></i>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-col>
            <v-col cols="12" class="text-center">
              <!-- :disabled="interaction_serial === null" -->
              <v-btn
                rounded
                large
                color="primary"
                :disabled="$v.task.$invalid"
                @click="saveTask"
                width="25%"
                >End Interaction</v-btn
              >
              <v-btn
                v-if="checking"
                rounded
                large
                color="info"
                class="mx-3"
                width="25%"
                :disabled="$v.task.$invalid"
                @click="workList"
                >Worklist</v-btn
              >
              <v-btn
                v-if="checking"
                rounded
                large
                color="success"
                width="25%"
                :disabled="$v.task.$invalid"
                @click="nextTask"
                >Next Task</v-btn
              >
              <!-- {{ interaction_serial + "dd" }} -->
            </v-col>
          </v-row>
        </form></formWrapper
      >
    </v-card-text>
  </v-card>
</template>

<script>
import { IndexData, UpdateData } from "@/helpers/apiMethods";
import { required } from "vuelidate/lib/validators";
import TableHeaders from "@/helpers/TableHeaders";

export default {
  props: {
    interaction_serial: {
      type: String,
      default: () => {}
    },
    task_id: {
      type: Number,
      default: () => {}
    },
    task_serial: {
      type: String,
      default: () => {}
    },
    dialogNotes: {
      type: String,
      default: () => {}
    },
    timer: {
      type: Object,
      required: true
    }
  },
  components: {
    DateTimePicker: () => import("@/components/DateTimePicker")
  },
  computed: {
    checking() {
      if (this.task_id != undefined || this.task_id != null) {
        return true;
      } else {
        return false;
      }
    },
    currentTime() {
      return `${this.timer.hours} : ${this.timer.minutes} : ${this.timer.seconds}`;
    }
  },
  data() {
    return {
      channels: [],
      classifications: [],
      actions: [],
      taskTypes: [],
      agents: [],
      taskStatuses: [],
      escalated: [
        { id: 0, name: "Never Escalated" },
        { id: 1, name: "Escalated Level One" },
        { id: 2, name: "Escalated Level two" }
      ],
      task: {
        classification_id: null,
        channel_id: null,
        action_id: null,
        close_task: 0,
        escalation_level: 0,
        // task_id: this.task_id,
        notes: this.dialogNotes
      },
      taskAdd: false,
      task_adding: {
        subject: null,
        due_date: "",
        type_id: {
          name: "",
          id: ""
        },
        agent_id: {
          name: "",
          id: ""
        },
        status_id: {
          name: "",
          id: ""
        },
        escalation_level: {
          name: "",
          id: ""
        },
        notes: ""
      },
      tasks_headers: [],
      tasks_added: [],
      queues: [],
      queueAgent: false,
      queueAgentTask: false,
      globalServerErrors: null
    };
  },
  created() {
    this.indexChannels();
    this.indexClassifications();
    this.indexActions();
    this.indextaskTypes();
    this.indexagents();
    this.indexqueues();
    this.indextaskStatuses();
    this.createTableHeaders();
  },
  methods: {
    indexChannels() {
      IndexData({ reqName: "crm/channels" })
        .then(res => {
          const { data } = res.data;
          this.channels = data;
        })
        .catch(() => {})
        .finally(() => {});
    },
    indexClassifications() {
      IndexData({ reqName: "crm/classifications" })
        .then(res => {
          const { data } = res.data;
          this.classifications = data;
        })
        .catch(() => {})
        .finally(() => {});
    },
    indexActions() {
      IndexData({ reqName: "crm/actions" })
        .then(res => {
          const { data } = res.data;
          this.actions = data;
        })
        .catch(() => {})
        .finally(() => {});
    },
    indextaskTypes() {
      IndexData({ reqName: "crm/task-types" })
        .then(res => {
          const { data } = res.data;
          this.taskTypes = data;
        })
        .catch(() => {})
        .finally(() => {});
    },
    indexagents() {
      IndexData({ reqName: "crm/agents" })
        .then(res => {
          const { data } = res.data;
          this.agents = data;
        })
        .catch(() => {})
        .finally(() => {});
    },
    indexqueues() {
      IndexData({ reqName: "crm/queues" })
        .then(res => {
          // const { data } = res.data;
          this.queues = res.data.queues;
          // console.log();
        })
        .catch(() => {})
        .finally(() => {});
    },
    indextaskStatuses() {
      IndexData({ reqName: "crm/task-statuses" })
        .then(res => {
          const { data } = res.data;
          this.taskStatuses = data;
        })
        .catch(() => {})
        .finally(() => {});
    },
    createTableHeaders() {
      const headersList = [
        "Subject",
        "Due Date",
        "Task Type",
        "Agent",
        "Task Status",
        "Escalation Level",
        "Notes",
        "Discard"
      ];
      this.tasks_headers = TableHeaders(headersList);
    },
    addNewTask() {
      this.taskAdd = !this.taskAdd;
    },
    allowedDates(value) {
      const previesDate = new Date(value);
      const currentDate = new Date(
        new Date().setDate(new Date().getDate() - 1)
      );
      return previesDate > currentDate;
    },
    taskTypeID() {
      const type_id = this.task_adding.type_id.id;
      this.taskTypes.forEach(item => {
        if (item.id === type_id) {
          this.task_adding.type_id = item;
        }
      });
    },
    agentID() {
      const agent_id = this.task_adding.agent_id.id;
      this.agents.forEach(item => {
        if (item.id === agent_id) {
          this.task_adding.agent_id = item;
        }
      });
    },
    statusID() {
      const status_id = this.task_adding.status_id.id;
      this.taskStatuses.forEach(item => {
        if (item.id === status_id) {
          this.task_adding.status_id = item;
        }
      });
    },
    escalationID() {
      const escalation_level = this.task_adding.escalation_level.id;
      this.escalated.forEach(item => {
        if (item.id === escalation_level) {
          this.task_adding.escalation_level = item;
        }
      });
    },
    addTableTask() {
      this.tasks_added.push(this.task_adding);
      this.resetTaskData();
      this.addNewTask();
    },
    saveTask() {
      const formData = new FormData();
      const dateFormat = "YYYY-MM-DD HH:mm:ss";
      this.task.due_date = this.$moment(this.task.due_date).format(dateFormat);
      Object.keys(this.task).forEach(formItem => {
        if (formItem === null) {
          return;
        } else if (formItem == "due_date") {
          if (this.task.close_task == 1) {
            return;
          } else if (this.task.close_task == 0) {
            const timeNow = this.$moment(new Date()).format(dateFormat);
            if (this.task.due_date == timeNow) {
              return;
            } else {
              formData.append("due_date", this.task.due_date);
            }
          }
        } else {
          formData.append(formItem, this.task[formItem]);
        }
      });
      if (this.task_id === undefined) {
        formData.append("task_id", "");
      } else {
        formData.append("task_id", this.task_id);
      }
      formData.append("_method", "put");

      if (this.tasks_added.length > 0) {
        this.tasks_added.forEach((item, index) => {
          Object.keys(item).forEach(task => {
            if (task === "due_date") {
              formData.append(
                `tasks[${index}][${task}]`,
                this.$moment(item[task]).format("YYYY-MM-DD HH:mm:ss")
              );
            }
            if (
              task === "type_id" ||
              task === "agent_id" ||
              task === "status_id" ||
              task === "escalation_level"
            ) {
              formData.append(`tasks[${index}][${task}]`, item[task].id);
            } else if (task === "due_date") {
              return;
            } else {
              formData.append(`tasks[${index}][${task}]`, item[task]);
            }
          });
        });
      }
      UpdateData({
        reqName: `crm/interactions`,
        data: formData,
        id: this.interaction_serial
      })
        .then(() => {
          this.$emit("endCall");
          this.resetWrapUpData();
        })
        .catch(err => {
          this.globalServerErrors = err.response.data.errors;
        })
        .finally(() => {});
    },
    workList() {
      this.saveTask();
      this.$router.push("WorkList");
    },
    nextTask() {
      this.saveTask();
    },
    handleDelete(item) {
      const index = this.tasks_added.indexOf(item);
      this.tasks_added.splice(index, 1);
    },
    resetTaskData() {
      this.task_adding = {
        subject: null,
        due_date: "",
        type_id: {
          name: "",
          id: ""
        },
        agent_id: {
          name: "",
          id: ""
        },
        status_id: {
          name: "",
          id: ""
        },
        escalation_level: {
          name: "",
          id: ""
        },
        notes: null
      };
    },
    resetWrapUpData() {
      this.$v.$reset();
      this.task = {
        classification_id: null,
        channel_id: null,
        action_id: null,
        notes: null
      };
    },
    retunBoolean() {
      if (this.task.close_task === "0") {
        return false;
      } else if (this.task.close_task === "1") {
        return true;
      }
    },
    taskIdCheck() {
      setTimeout(() => {
        if (this.task_id === undefined) {
          return true;
        } else {
          return false;
        }
      }, 500);
    }
  },
  validations() {
    return {
      task: {
        classification_id: {
          required
        },
        channel_id: {
          required
        },
        // escalation_level: {
        //   required: requiredIf(task => {
        //     return task.close_task;
        //   })
        // },
        action_id: {
          required
        },
        notes: {
          required
        }
      }
    };
  }
};
</script>
